import { useDynamicForm } from "@/components/dynamic-form/hook/useDynamicForm";
import { PageContainer } from "@/components/page-container";
import { TableContainer } from "@/components/table-container";
import { Table } from "@renderbus/ui";
import { useWatchPagination } from "@/components/dynamic-form/hook/useWatchPagination";
import { useColumns } from "@/pages/payment/hooks/useColumns";
import { usePaymentStore } from "../../store/payment-store";
import { RechargeRecordTabType } from "../../constants";
import { useCallback, useEffect } from "react";
import { CouponDetailType } from "@/constant";

export function CouponRechargeRecord() {
  const { tableData, pageNum, fetchData, setPageNum, total, pageSize } =
    useDynamicForm({
      api: "/api/rendering/pay/recharge/queryUserCouponRecords",
      defaultPageSize: 10,
    });

  const _fetchData = useCallback(async () => {
    await fetchData({
      extraData: {
        couponType: [
          CouponDetailType.Offline,
          CouponDetailType.GPU,
          CouponDetailType.CPU,
          CouponDetailType.Universal,
          CouponDetailType.CPUQing,
          CouponDetailType.GPUQing,
        ],
      },
    });
  }, [fetchData]);

  useWatchPagination(pageSize, pageNum, _fetchData);

  const { columns } = useColumns();
  const { activeTabKey } = usePaymentStore();

  useEffect(() => {
    if (activeTabKey === RechargeRecordTabType.Coupon) {
      _fetchData();
    }
  }, [activeTabKey, _fetchData]);
  return (
    <PageContainer>
      <TableContainer>
        <Table
          paginationCurrent={pageNum}
          columns={columns}
          dataSource={tableData}
          gap={false}
          total={total}
          defaultPageSize={pageSize}
          onPageNumChange={async (num) => {
            setPageNum(num);
          }}
        />
      </TableContainer>
    </PageContainer>
  );
}
